import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import {
  runsUsvcMigrationsContent,
  runMigrationUsvcMigrationsContent,
} from './UsvcMigrationsContent';

export const usvcMigrationsPlugin = createFrontendPlugin({
  pluginId: 'usvc-migrations',
  extensions: [runsUsvcMigrationsContent, runMigrationUsvcMigrationsContent],
});
